import { Controller } from "@hotwired/stimulus"

// Copy a target's value to the clipboard. Briefly swaps the button label to
// "Copied!" as confirmation. Used by the study group invite-link card.
export default class extends Controller {
  static targets = ["source", "label", "button"]

  copy() {
    if (!this.hasSourceTarget) return
    const value = this.sourceTarget.value || this.sourceTarget.textContent
    navigator.clipboard.writeText(value).then(() => this.showCopied()).catch(() => this.fallbackCopy(value))
  }

  selectAll(event) {
    event.currentTarget.select()
  }

  showCopied() {
    if (!this.hasLabelTarget) return
    const original = this.labelTarget.textContent
    this.labelTarget.textContent = "Copied!"
    if (this.hasButtonTarget) this.buttonTarget.classList.add("text-green-700")
    setTimeout(() => {
      this.labelTarget.textContent = original
      if (this.hasButtonTarget) this.buttonTarget.classList.remove("text-green-700")
    }, 1500)
  }

  // For older browsers / insecure contexts where navigator.clipboard isn't available.
  fallbackCopy(value) {
    const tmp = document.createElement("textarea")
    tmp.value = value
    document.body.appendChild(tmp)
    tmp.select()
    try { document.execCommand("copy") } catch {}
    document.body.removeChild(tmp)
    this.showCopied()
  }
}
